import { render, staticRenderFns } from "./OTPValidation.vue?vue&type=template&id=5c0f7bfd&scoped=true&"
import script from "./OTPValidation.vue?vue&type=script&lang=js&"
export * from "./OTPValidation.vue?vue&type=script&lang=js&"
import style0 from "./OTPValidation.vue?vue&type=style&index=0&id=5c0f7bfd&lang=scss&scoped=true&"
import style1 from "./OTPValidation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0f7bfd",
  null
  
)

export default component.exports